<template>
  <div  :class="this.$route.query.yanse == 1 ? 'apply-loan-container2' :  'apply-loan-container'">
    <section class="apply-loan" ref="applyLoan">
      <div class="srot_grislge" v-if="this.$route.query.yanse != 3">
          <el-steps :active="this.$store.state[1].activeNum" align-center>
            <el-step title="步骤1" description=""></el-step>
            <el-step title="步骤2" description=""></el-step>
            <el-step title="步骤3" description=""></el-step>
            <el-step title="步骤4" description=""></el-step>
            <el-step title="步骤5" description=""></el-step>
          </el-steps>
        </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"  class="apply-loan__router-view" ref="applyLoanRouterView"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"  class="apply-loan__router-view" ref="applyLoanRouterView"></router-view>
    </section>
  </div>
  
</template>

<script>
  export default {
    data () {
      return {
      };
    },
    created () {
      this.$route.query.yanse;
    },
    mounted () {
//      this.$refs.applyLoan.style.height = `${window.innerHeight - 50 - 30}px`
    }
  };
</script>
<style lang="scss">
.srot_grislge{
  // display: flex;
  margin: 0 auto;
  margin-top: 20px;
  padding-left: 14%;
  // justify-content: center;
}
  .apply-loan-container {
    /*overflow: auto;*/
    /*height:100%;*/
    overflow: hidden;
    background: #f7e8c4;
  }
  .apply-loan-container2 {
    /*overflow: auto;*/
    /*height:100%;*/
    overflow: hidden;
    background: #c4f7cf;
  }

  .apply-loan {
    margin: 0 auto;
    width: $containerWidth;
  }

  .apply-loan__router-view {
    @include resetBFC;
    padding-top: 20px;
    padding-bottom: 20px;
    min-height: 550px;
  }
</style>



// WEBPACK FOOTER //
// ApplyLoan.vue?4be5c900